/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonParentTypesFromJSON, } from './InternalCommonParentTypes';
import { SkinToneFromJSON, } from './SkinTone';
import { InternalUserReactionsEmojiResponseV3EmojiFromJSON, InternalUserReactionsEmojiResponseV3EmojiToJSON, } from './InternalUserReactionsEmojiResponseV3Emoji';
import { InternalUserReactionsEmojiResponseV3UserFromJSON, InternalUserReactionsEmojiResponseV3UserToJSON, } from './InternalUserReactionsEmojiResponseV3User';
/**
 * Check if a given object implements the InternalUserReactionsEmojiResponseV3 interface.
 */
export function instanceOfInternalUserReactionsEmojiResponseV3(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('user' in value) || value['user'] === undefined)
        return false;
    if (!('parentId' in value) || value['parentId'] === undefined)
        return false;
    if (!('parentType' in value) || value['parentType'] === undefined)
        return false;
    if (!('emoji' in value) || value['emoji'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
export function InternalUserReactionsEmojiResponseV3FromJSON(json) {
    return InternalUserReactionsEmojiResponseV3FromJSONTyped(json, false);
}
export function InternalUserReactionsEmojiResponseV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'user': InternalUserReactionsEmojiResponseV3UserFromJSON(json['user']),
        'parentId': json['parent_id'],
        'parentType': InternalCommonParentTypesFromJSON(json['parent_type']),
        'emoji': InternalUserReactionsEmojiResponseV3EmojiFromJSON(json['emoji']),
        'skinTone': json['skin_tone'] == null ? undefined : SkinToneFromJSON(json['skin_tone']),
        'createdAt': (new Date(json['created_at'])),
    };
}
export function InternalUserReactionsEmojiResponseV3ToJSON(json) {
    return InternalUserReactionsEmojiResponseV3ToJSONTyped(json, false);
}
export function InternalUserReactionsEmojiResponseV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'user': InternalUserReactionsEmojiResponseV3UserToJSON(value['user']),
        'emoji': InternalUserReactionsEmojiResponseV3EmojiToJSON(value['emoji']),
    };
}
